import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useLocation,
} from "react-router-dom";
import "./App.css";

import HireTalent from "./pages/HireTalent";
import Privacy from "./pages/PrivacyPolicy";
import Refund from "./pages/RefundPolicy";
import Consultation from "./pages/Consultation";
import Products from "./pages/Products";
import Payroll from "./pages/Payroll";
import Apply from "./pages/Apply";
import TaxPage from "./pages/TaxPage";
import Staffing from "./pages/staffing";
import { Terms } from "./pages/Terms";
import Proposal from "./components/Proposal";
import Event from "./pages/Event";
import OracleNetSuite from "./ServicesAndSolution/OracleNetSuite";
import OdooPage from "./ServicesAndSolution/OdooPage";
import ZohoServicesPage from "./ServicesAndSolution/ZohoFinal";
import Einv from "./pages/Einv";
import ImpactOfEinv from "./pages/ImpactOfEinv";
import HowToComply from "./pages/HowToComply";
import CloudareForEInv from "./pages/CloudareForEInv";
import About from "./pages/About";
import OracleFusionServicesPage from "./ServicesAndSolution/OracleFusionServices";
import OracleEbsServicesPage from "./ServicesAndSolution/OracleEbsServicesPage";
import OracleEnterpriseServicesPage from "./ServicesAndSolution/OracleEnterpriseServices";
import Locations from "./pages/Locations";
import Contact from "./pages/ContactPage";
import SuccessStories from "./pages/SuccessStories";
import AlliancesAndTestimonials from "./pages/AlliancesAndTestimonials";
import AwardsAndAchievements from "./pages/AwardsAndAchievements";
import EventsAndWebinars from "./pages/EventsAndWebinars";
import NotFound from "./pages/NotFound";
import FAQ from "./pages/FAQ";
import PartnersPage from "./pages/PartnersPage";
import DecisionPage from "./pages/DecisionPage";
import ErpPage from "./pages/ErpPage";
import ErpIntegrationPage from "./pages/ErpIntegrationPage";
import RaipurPage from "./pages/RaipurPage";

import ScrollToTop from "./components/ScrollToTop";
import { initAnalytics, trackPageView } from "./analytics";

function AppRoutes() {
  return (
    <Routes>
      {/* Content pages */}
      <Route path="/" element={<Products />} />
      <Route path="/solutions" element={<Navigate replace to="/" />} />
      <Route path="/about" element={<About />} />
      <Route path="/contact-us" element={<Contact />} />
      <Route path="/locations" element={<Locations />} />
      <Route path="/consultation" element={<Consultation />} />
      <Route path="/faq" element={<FAQ />} />

      {/* ===== CANONICAL: /tax/{country} compliance pages ===== */}
      <Route path="/tax/:country" element={<TaxPage />} />

      {/* ===== v6 new pages ===== */}
      <Route path="/partners" element={<PartnersPage />} />
      <Route path="/gsp-asp-pdp" element={<DecisionPage />} />
      <Route path="/einvoicing-erp-integration" element={<ErpIntegrationPage />} />
      <Route path="/erp/:platform" element={<ErpPage />} />
      <Route path="/raipur" element={<RaipurPage />} />

      {/* ===== CANONICAL: /services/{practice} ===== */}
      <Route path="/services/oracle" element={<OracleEnterpriseServicesPage />} />
      <Route path="/services/zoho" element={<ZohoServicesPage />} />
      <Route path="/services/staffing" element={<Staffing />} />
      <Route path="/services/payroll" element={<Payroll />} />
      <Route path="/services/netsuite" element={<OracleNetSuite />} />
      <Route path="/services/odoo" element={<OdooPage />} />
      <Route path="/services/fusion" element={<OracleFusionServicesPage />} />
      <Route path="/services/ebs" element={<OracleEbsServicesPage />} />

      {/* HR / hiring */}
      <Route path="/hire-talent" element={<HireTalent />} />
      <Route path="/apply" element={<Apply />} />

      {/* Knowledge hub */}
      <Route path="/einv" element={<Einv />} />
      <Route path="/peppol" element={<Navigate replace to="/tax/eu" />} />
      <Route path="/impact-of-einvoicing" element={<ImpactOfEinv />} />
      <Route path="/how-to-comply" element={<HowToComply />} />
      <Route path="/cloudare-for-einvoicing" element={<CloudareForEInv />} />
      {/* legacy camelCase -> kebab redirects */}
      <Route path="/ImpactOfEinv" element={<Navigate replace to="/impact-of-einvoicing" />} />
      <Route path="/HowToComply" element={<Navigate replace to="/how-to-comply" />} />
      <Route path="/CloudareForEinv" element={<Navigate replace to="/cloudare-for-einvoicing" />} />

      {/* ===== 301 redirects: old tax URLs -> canonical /tax/* ===== */}
      <Route path="/tax/my" element={<Navigate replace to="/tax/malaysia" />} />
      <Route path="/tax/lhdn" element={<Navigate replace to="/tax/malaysia" />} />
      <Route path="/services-zatca" element={<Navigate replace to="/tax/ksa" />} />
      <Route path="/services-lhdn" element={<Navigate replace to="/tax/malaysia" />} />
      <Route path="/services-gst" element={<Navigate replace to="/tax/india" />} />
      <Route path="/services-fta-uae" element={<Navigate replace to="/tax/uae" />} />
      <Route path="/services-uae" element={<Navigate replace to="/tax/uae" />} />

      {/* ===== 301 redirects: old service URLs -> canonical /services/* ===== */}
      <Route path="/services-oracle" element={<Navigate replace to="/services/oracle" />} />
      <Route path="/services-oracleenterprises" element={<Navigate replace to="/services/oracle" />} />
      <Route path="/services-OracleEnterprises" element={<Navigate replace to="/services/oracle" />} />
      <Route path="/services-zoho" element={<Navigate replace to="/services/zoho" />} />
      <Route path="/services-netsuite" element={<Navigate replace to="/services/netsuite" />} />
      <Route path="/services-NetSuite" element={<Navigate replace to="/services/netsuite" />} />
      <Route path="/services-odoo" element={<Navigate replace to="/services/odoo" />} />
      <Route path="/services-Odoo" element={<Navigate replace to="/services/odoo" />} />
      <Route path="/services-fusion" element={<Navigate replace to="/services/fusion" />} />
      <Route path="/services-ebs" element={<Navigate replace to="/services/ebs" />} />
      <Route path="/staffing" element={<Navigate replace to="/services/staffing" />} />
      <Route path="/payroll" element={<Navigate replace to="/services/payroll" />} />
      <Route path="/services" element={<Navigate replace to="/services/oracle" />} />
      <Route path="/oracle-netsuite-services" element={<Navigate replace to="/services/netsuite" />} />

      {/* Success stories — fix legacy typo URL with redirect */}
      <Route path="/success-stories" element={<SuccessStories />} />
      <Route path="/suceess-stories" element={<Navigate replace to="/success-stories" />} />

      <Route path="/alliances" element={<AlliancesAndTestimonials />} />
      <Route path="/awards-and-achievements" element={<AwardsAndAchievements />} />
      <Route path="/events-and-webinars" element={<EventsAndWebinars />} />
      {/* legacy camelCase -> kebab redirects */}
      <Route path="/awardsAndAchievements" element={<Navigate replace to="/awards-and-achievements" />} />
      <Route path="/EventAndWebinars" element={<Navigate replace to="/events-and-webinars" />} />

      {/* Legal */}
      <Route path="/privacy-policy" element={<Privacy />} />
      <Route path="/refund-policy" element={<Refund />} />
      <Route path="/terms" element={<Terms />} />

      {/* Misc */}
      <Route path="/proposal" element={<Proposal />} />
      <Route path="/scan-me" element={<Event />} />

      {/* Catch-all */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

// Tracks pageviews on every navigation (must live inside <Router>)
function PageViewTracker() {
  const location = useLocation();
  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);
  return null;
}

function App() {
  useEffect(() => {
    initAnalytics();
  }, []);

  return (
    <div className="App">
      <Router>
        <ScrollToTop />
        <PageViewTracker />
        <AppRoutes />
      </Router>
    </div>
  );
}

export default App;
